import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "product_gift_info" }
const _hoisted_2 = { class: "gift_tit" }
const _hoisted_3 = {
  key: 0,
  class: "staet_btn_area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("dl", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.items, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: "gift_text_list"
      }, [
        _createVNode("dt", _hoisted_2, _toDisplayString(item.name), 1),
        _createVNode("dd", {
          class: ["gift_txt", {'state': item.isState}]
        }, [
          (item.isPhoneNumber)
            ? (_openBlock(), _createBlock("a", {
                key: 0,
                href: 'tel:' + item.value,
                class: "tel"
              }, _toDisplayString(item.value), 9, ["href"]))
            : (item.isLink)
              ? (_openBlock(), _createBlock("a", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('clickLink')), ["prevent"])),
                  href: "#",
                  class: "btn_view"
                }, _toDisplayString(item.value), 1))
              : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(item.value) + " ", 1),
                  (item.hasBtn)
                    ? (_openBlock(), _createBlock("div", _hoisted_3, [
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn_oreder_cancle",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('clickBtn')))
                        }, _toDisplayString(item.btnName), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
        ], 2)
      ]))
    }), 128))
  ]))
}